export const el = {
  nav: {
    how: 'Πώς λειτουργεί',
    pricing: 'Τιμές',
    login: 'Σύνδεση',
  },
  hero: {
    badge: 'AI-Powered Project Management',
    title1: 'Διαχείριση έργων,',
    title2: 'πιο εύκολη από ποτέ.',
    subtitle: 'Ρίσκα, χρονοδιάγραμμα, budget και reporting σε ένα εργαλείο — με AI που αναλαμβάνει τη βαριά δουλειά για εσάς.',
    cta: 'Ξεκινήστε τώρα →',
    learn: 'Μάθετε περισσότερα',
  },
  features: {
    label: 'Δυνατότητες',
    title: 'Ό,τι χρειάζεστε σε ένα εργαλείο',
    items: [
      { icon: '✦', title: 'AI-Powered Ανάλυση', desc: 'Ανεβάστε τη σύμβαση και το AI εξάγει αυτόματα ρίσκα, χρονοδιάγραμμα, budget και stakeholders σε δευτερόλεπτα.' },
      { icon: '◈', title: 'Διαχείριση Ρίσκων', desc: 'Εντοπίστε, αξιολογήστε και παρακολουθήστε κινδύνους σε πραγματικό χρόνο — κατηγοριοποιημένους ανά διάσταση.' },
      { icon: '▤', title: 'Έξυπνο Χρονοδιάγραμμα', desc: 'Φάσεις, activities και milestones οργανωμένα αυτόματα. Gantt chart και κρίσιμη διαδρομή με ένα κλικ.' },
      { icon: '◎', title: 'AI Project Advisor', desc: 'Ο ψηφιακός σας PM consultant. Αναλύει meetings, emails και δεδομένα — και σας προτείνει ενέργειες βάσει του έργου σας.' },
    ],
  },
  how: {
    label: 'Διαδικασία',
    title: 'Πώς λειτουργεί',
    steps: [
      { num: '01', title: 'Μοιραστείτε τα δεδομένα του έργου σας', desc: 'Με τη δύναμη του AI αποκτήστε άμεσα ορατότητα στο χρονοδιάγραμμα, στους πιθανούς κινδύνους και στα επόμενα βήματα.' },
      { num: '02', title: 'Παρακολουθήστε σε πραγματικό χρόνο', desc: 'Ρίσκα, issues και χρονοδιάγραμμα σε ένα ενιαίο dashboard. Ενημερώσεις από meetings και emails αυτόματα.' },
      { num: '03', title: 'Αποφασίστε με δεδομένα', desc: 'Αναφορές και AI insights που σας δίνουν την πλήρη εικόνα για να παραδώσετε επιτυχημένα έργα.' },
    ],
  },
  pricing: {
    label: 'Πακετα Συνδρομης',
    title: 'Απλά και διαφανή πλάνα',
    subtitle: 'Χωρίς κρυφές χρεώσεις. Ακυρώστε οποτεδήποτε.',
    popular: 'Πιο δημοφιλές',
    perMonth: '/μήνα',
    cta: (name: string) => `Ξεκινήστε με ${name} →`,
  },
  trial: {
    title: 'Απολαύστε Δωρεάν το eazyproject',
    subtitle: '10 ημέρες πλήρης πρόσβαση  ·  1 έργο  ·  Χωρίς δέσμευση πληρωμής',
    cta: 'Ξεκινήστε Δωρεάν →',
  },
  faq: {
    label: 'FAQ',
    title: 'Συχνές ερωτήσεις',
    items: [
      { q: 'Χρειάζομαι δικό μου AI key;', a: 'Ναι, το eazyproject λειτουργεί με το δικό σας AI key (BYO — Bring Your Own). Υποστηρίζουμε OpenAI (GPT-4o κ.ά.) και Anthropic Claude. Έτσι έχετε πλήρη έλεγχο των δεδομένων σας και του κόστους χρήσης AI.' },
      { q: 'Πόσο γρήγορα μπορώ να ξεκινήσω;', a: 'Σε λιγότερο από 5 λεπτά. Δημιουργείτε λογαριασμό, μοιράζεστε τα δεδομένα του έργου σας και το AI αναλαμβάνει το υπόλοιπο.' },
      { q: 'Τι γίνεται μετά τις 10 ημέρες δωρεάν δοκιμής;', a: 'Ο λογαριασμός σας παγώνει αυτόματα χωρίς καμία χρέωση. Μπορείτε να επιλέξετε πακέτο για να συνεχίσετε — χωρίς δέσμευση.' },
      { q: 'Μπορώ να αλλάξω πακέτο αργότερα;', a: 'Φυσικά. Μπορείτε να αναβαθμίσετε ή να υποβαθμίσετε οποιαδήποτε στιγμή. Επικοινωνήστε μαζί μας και θα σας εξυπηρετήσουμε άμεσα.' },
      { q: 'Τα δεδομένα μου είναι ασφαλή;', a: 'Ναι. Τα δεδομένα σας αποθηκεύονται σε ασφαλείς servers με κρυπτογράφηση και δεν κοινοποιούνται ποτέ σε τρίτους.' },
      { q: 'Πόσοι χρήστες μπορούν να έχουν πρόσβαση;', a: 'Εξαρτάται από το πακέτο: Starter έως 10, Pro έως 20, Enterprise έως 50 χρήστες.' },
      { q: 'Υπάρχει σύμβαση ή δέσμευση;', a: 'Όχι. Η συνδρομή είναι μηνιαία και μπορείτε να την ακυρώσετε οποιαδήποτε στιγμή χωρίς ποινή.' },
    ],
  },
  cta: {
    title: 'Έτοιμοι να ξεκινήσετε;',
    subtitle: 'Αποκτήστε πρόσβαση στο πιο έξυπνο εργαλείο διαχείρισης έργων. Επικοινωνήστε μαζί μας για demo ή άμεση πρόσβαση.',
    login: 'Σύνδεση →',
    contact: 'Επικοινωνία',
  },
  loginModal: {
    welcome: 'Καλωσήρθατε',
    subtitle: 'Συνδεθείτε στον λογαριασμό σας',
    password: 'Κωδικός',
    show: 'Εμφάνιση',
    hide: 'Απόκρυψη',
    error: 'Λάθος email ή κωδικός',
    submit: 'Είσοδος →',
    submitting: 'Σύνδεση...',
    forgot: 'Ξέχασα τον κωδικό μου',
  },
  forgotModal: {
    title: 'Επαναφορά κωδικού',
    subtitle: 'Θα σας στείλουμε έναν προσωρινό κωδικό',
    info: 'Εισάγετε το email σας και θα λάβετε έναν προσωρινό κωδικό για να συνδεθείτε.',
    emailLabel: 'Email λογαριασμού',
    submit: 'Αποστολή προσωρινού κωδικού',
    submitting: 'Αποστολή...',
    back: '← Επιστροφή στη σύνδεση',
    error: 'Προέκυψε σφάλμα. Παρακαλώ δοκιμάστε ξανά.',
  },
  forgotSuccess: {
    title: 'Email αποστάλθηκε!',
    body: (email: string) => `Αν το email ${email} υπάρχει στο σύστημα, θα λάβετε τον προσωρινό κωδικό σας σε λίγα δευτερόλεπτα.`,
    spam: 'Ελέγξτε και τον φάκελο spam αν δεν το βλέπετε.',
    back: 'Επιστροφή στη σύνδεση',
  },
  pricingModal: {
    title: (name: string) => `Πλάνο ${name}`,
    subtitle: 'Συμπληρώστε τα στοιχεία σας για να συνεχίσετε στην πληρωμή',
    orgLabel: 'Όνομα οργανισμού',
    orgNamePlaceholder: 'π.χ. ABC Consulting',
    emailLabel: 'Email διαχειριστή',
    note: 'Μετά την πληρωμή θα λάβετε email με τα credentials σύνδεσης.',
    cancel: 'Άκυρο',
    submit: 'Συνέχεια στην πληρωμή →',
    submitting: 'Ανακατεύθυνση...',
  },
  trialModal: {
    title: 'Απολαύστε Δωρεάν το eazyproject',
    subtitle: '10 ημέρες  ·  1 έργο  ·  Χωρίς δέσμευση πληρωμής',
    orgLabel: 'Όνομα οργανισμού',
    orgNamePlaceholder: 'π.χ. ABC Consulting',
    emailLabel: 'Email διαχειριστή',
    submit: 'Ξεκινήστε Δωρεάν →',
    submitting: 'Δημιουργία λογαριασμού...',
    note: 'Θα λάβετε email με τα credentials σύνδεσης αμέσως.',
    successTitle: 'Η δοκιμή σας είναι έτοιμη!',
    successBody: 'Θα λάβετε σε λίγα δευτερόλεπτα email με τα credentials σύνδεσης.',
    successSpam: 'Ελέγξτε και τον φάκελο spam αν δεν το βλέπετε.',
    successCta: 'Σύνδεση →',
    error: 'Προέκυψε σφάλμα. Δοκιμάστε ξανά.',
  },
  checkoutError: 'Σφάλμα κατά την ανακατεύθυνση στο checkout',
  planFeatures: {
    unlimitedProjects: 'Απεριόριστα έργα',
    maxProjects: (n: number) => `Έως ${n} ενεργά έργα`,
    unlimitedUsers: 'Απεριόριστοι χρήστες',
    maxUsers: (n: number) => `Έως ${n} χρήστες`,
  },
  planCatalog: {
    starter: { desc: 'Για μικρές ομάδες και μεμονωμένους PM', features: ['AI Advisor', 'BYO AI Key', 'Email support'] },
    pro:     { desc: 'Για αναπτυσσόμενες εταιρείες',          features: ['AI ανάλυση + Advisor', 'BYO AI Key', 'Priority support'] },
    enterprise: { desc: 'Για οργανισμούς με πολλά έργα',      features: ['Όλες οι AI λειτουργίες', 'Dedicated support', 'Custom onboarding'] },
  },
  themeToggle: {
    toDark: 'Εναλλαγή σε νύχτα',
    toLight: 'Εναλλαγή σε ημέρα',
  },
  stats: [
    { value: '3 σε 1', label: 'Schedule · Budget · AI' },
    { value: 'Gmail sync', label: 'Email ανάλυση με AI' },
    { value: 'BYO Key', label: 'Φέρτε το δικό σας AI key' },
    { value: 'EVM', label: 'Earned Value Management' },
  ],
  demo: {
    title: 'Δείτε την εφαρμογή σε δράση',
  },
  comparison: {
    label: 'ΓΙΑΤΙ EAZYPROJECT',
    title: 'Φτιαγμένο για project managers',
    subtitle: 'Εστιαζόμαστε σε αυτά που πραγματικά χρειάζεστε — χωρίς bloat, χωρίς κρυφά κόστη.',
    features: ['AI Project Advisor', 'Email AI ανάλυση', 'EVM & Budget tracking', 'Gantt chart', 'BYO AI Key'],
    note: '',
    miniCtaNote: '10 ημέρες πλήρης πρόσβαση · χωρίς πιστωτική κάρτα',
  },
};

export const en: typeof el = {
  nav: {
    how: 'How it works',
    pricing: 'Pricing',
    login: 'Sign in',
  },
  hero: {
    badge: 'AI-Powered Project Management',
    title1: 'Project management,',
    title2: 'easier than ever.',
    subtitle: 'Risks, schedule, budget and reporting in one tool — with AI that handles the heavy lifting for you.',
    cta: 'Get started →',
    learn: 'Learn more',
  },
  features: {
    label: 'Features',
    title: 'Everything you need in one tool',
    items: [
      { icon: '✦', title: 'AI-Powered Analysis', desc: 'Upload your contract and AI automatically extracts risks, schedule, budget and stakeholders in seconds.' },
      { icon: '◈', title: 'Risk Management', desc: 'Identify, assess and monitor risks in real time — categorised by dimension.' },
      { icon: '▤', title: 'Smart Schedule', desc: 'Phases, activities and milestones organised automatically. Gantt chart and critical path with one click.' },
      { icon: '◎', title: 'AI Project Advisor', desc: 'Your digital PM consultant. Analyses meetings, emails and data — and suggests actions based on your project.' },
    ],
  },
  how: {
    label: 'Process',
    title: 'How it works',
    steps: [
      { num: '01', title: 'Share your project data', desc: 'With the power of AI, gain immediate visibility into the schedule, potential risks and next steps.' },
      { num: '02', title: 'Monitor in real time', desc: 'Risks, issues and schedule in one unified dashboard. Updates from meetings and emails automatically.' },
      { num: '03', title: 'Decide with data', desc: 'Reports and AI insights that give you the full picture to deliver successful projects.' },
    ],
  },
  pricing: {
    label: 'Subscription Plans',
    title: 'Simple and transparent plans',
    subtitle: 'No hidden fees. Cancel anytime.',
    popular: 'Most popular',
    perMonth: '/month',
    cta: (name: string) => `Get started with ${name} →`,
  },
  trial: {
    title: 'Try eazyproject for Free',
    subtitle: '10 days full access  ·  1 project  ·  No payment commitment',
    cta: 'Start Free →',
  },
  faq: {
    label: 'FAQ',
    title: 'Frequently Asked Questions',
    items: [
      { q: 'Do I need my own AI key?', a: 'Yes, eazyproject works with your own AI key (BYO — Bring Your Own). We support both OpenAI (GPT-4o and others) and Anthropic Claude. This gives you full control over your data and AI usage costs.' },
      { q: 'How quickly can I get started?', a: 'In less than 5 minutes. Create an account, share your project data and AI takes care of the rest.' },
      { q: 'What happens after the 10-day free trial?', a: 'Your account freezes automatically with no charge. You can choose a plan to continue — no commitment.' },
      { q: 'Can I change plans later?', a: 'Of course. You can upgrade or downgrade at any time. Contact us and we\'ll assist you immediately.' },
      { q: 'Is my data safe?', a: 'Yes. Your data is stored on secure servers with encryption and is never shared with third parties.' },
      { q: 'How many users can have access?', a: 'Depends on the plan: Starter up to 10, Pro up to 20, Enterprise up to 50 users.' },
      { q: 'Is there a contract or commitment?', a: 'No. The subscription is monthly and you can cancel at any time without penalty.' },
    ],
  },
  cta: {
    title: 'Ready to get started?',
    subtitle: 'Get access to the smartest project management tool. Contact us for a demo or immediate access.',
    login: 'Sign in →',
    contact: 'Contact us',
  },
  loginModal: {
    welcome: 'Welcome',
    subtitle: 'Sign in to your account',
    password: 'Password',
    show: 'Show',
    hide: 'Hide',
    error: 'Wrong email or password',
    submit: 'Sign in →',
    submitting: 'Signing in...',
    forgot: 'Forgot my password',
  },
  forgotModal: {
    title: 'Reset password',
    subtitle: 'We\'ll send you a temporary password',
    info: 'Enter your email and you\'ll receive a temporary password to sign in.',
    emailLabel: 'Account email',
    submit: 'Send temporary password',
    submitting: 'Sending...',
    back: '← Back to sign in',
    error: 'An error occurred. Please try again.',
  },
  forgotSuccess: {
    title: 'Email sent!',
    body: (email: string) => `If the email ${email} exists in our system, you'll receive your temporary password in a few seconds.`,
    spam: 'Also check your spam folder if you don\'t see it.',
    back: 'Back to sign in',
  },
  pricingModal: {
    title: (name: string) => `Plan ${name}`,
    subtitle: 'Fill in your details to continue to payment',
    orgLabel: 'Organisation name',
    orgNamePlaceholder: 'e.g. ABC Consulting',
    emailLabel: 'Admin email',
    note: 'After payment you\'ll receive an email with your sign-in credentials.',
    cancel: 'Cancel',
    submit: 'Continue to payment →',
    submitting: 'Redirecting...',
  },
  trialModal: {
    title: 'Try eazyproject for Free',
    subtitle: '10 days  ·  1 project  ·  No payment commitment',
    orgLabel: 'Organisation name',
    orgNamePlaceholder: 'e.g. ABC Consulting',
    emailLabel: 'Admin email',
    submit: 'Start Free →',
    submitting: 'Creating account...',
    note: 'You\'ll receive an email with your sign-in credentials immediately.',
    successTitle: 'Your trial is ready!',
    successBody: 'You\'ll receive an email with your sign-in credentials in a few seconds.',
    successSpam: 'Also check your spam folder if you don\'t see it.',
    successCta: 'Sign in →',
    error: 'An error occurred. Please try again.',
  },
  checkoutError: 'Error redirecting to checkout',
  planFeatures: {
    unlimitedProjects: 'Unlimited projects',
    maxProjects: (n: number) => `Up to ${n} active projects`,
    unlimitedUsers: 'Unlimited users',
    maxUsers: (n: number) => `Up to ${n} users`,
  },
  planCatalog: {
    starter: { desc: 'For small teams and independent PMs', features: ['AI Advisor', 'BYO AI Key', 'Email support'] },
    pro:     { desc: 'For growing companies',                features: ['AI analysis + Advisor', 'BYO AI Key', 'Priority support'] },
    enterprise: { desc: 'For organisations with multiple projects', features: ['All AI features', 'Dedicated support', 'Custom onboarding'] },
  },
  themeToggle: {
    toDark: 'Switch to dark mode',
    toLight: 'Switch to light mode',
  },
  stats: [
    { value: '3 in 1', label: 'Schedule · Budget · AI' },
    { value: 'Gmail sync', label: 'Email AI analysis' },
    { value: 'BYO Key', label: 'Bring your own AI key' },
    { value: 'EVM', label: 'Earned Value Management' },
  ],
  demo: {
    title: 'See the app in action',
  },
  comparison: {
    label: 'WHY EAZYPROJECT',
    title: 'Built for project managers',
    subtitle: 'We focus on what you really need — no bloat, no hidden costs.',
    features: ['AI Project Advisor', 'Email AI analysis', 'EVM & Budget tracking', 'Gantt chart', 'BYO AI Key'],
    note: '',
    miniCtaNote: '10 days full access · no credit card required',
  },
};
